import React from 'react';
import ExecMetricsView from 'views/ExecMetricsView';
import { Section } from 'shared/ui/Section';
import { useReportSectionStatus } from 'shared/state/sectionStatusContext';
import { useCustomMetricsSection } from './useCustomMetricsSection';

/** CONF-212 in V2. Classic puts a "Custom Metrics" disclosure on the System
 *  Attributes card; V2's readouts live in the rail, which has no room for a
 *  four-column editor, so the panel is its own collapsed workbench section
 *  (sectionRegistry gates it on EXEC_CUSTOM_METRICS). The panel itself is the
 *  classic ExecMetricsView, reused as BomSection reuses ExecPricingView. */
export function CustomMetricsSection({ id }: { id: string }) {
  const s = useCustomMetricsSection();
  useReportSectionStatus(id, s.status);
  return (
    <Section.Root id={id} defaultOpen={false}>
      <Section.Bar title="Custom Metrics" role="Exec per-node throughput overrides"
        summary={s.summary} />
      <Section.Body>
        <ExecMetricsView execMetrics={s.execMetrics} baselineMetrics={s.baselineMetrics} config={s.config} staleKeys={s.staleKeys} />
      </Section.Body>
    </Section.Root>
  );
}
